import type { AnnotationValue } from "./Annotation/hook/useAnnotations";

export function getThresholdValue(
  entry: Pick<AnnotationValue, "value" | "thresholdValue">,
  useNormalizedGap: boolean,
): number | null {
  const value = useNormalizedGap ? entry.thresholdValue : entry.value;
  return value === null ? null : Number(value);
}
